const aboutDepartments = [
  {
    slug: 'enterprise-innovation',
    badge: 'Department Profile',
    title: '企业创新工作部',
    subtitle: '致力于构建企业级创新生态系统，通过前沿研究与战略协同，驱动组织持续进化与管理效能提升。',
    heroImage: require('@/assets/img/about-image.jpg'),
    missionTitle: '核心使命',
    missionParagraphs: [
      '企业创新工作部是连接管理理论、产业洞察与企业实践的重要桥梁。围绕企业高质量发展需求，部门持续跟踪国内外创新管理趋势，聚焦组织变革、流程优化、能力建设与数字化转型等关键课题，推动管理理念转化为可执行的落地方案。',
      '部门以平台化、协同化、专业化为工作导向，依托协会资源、专家力量与企业案例积累，帮助企业发现创新突破口、形成方法论沉淀，并逐步构建可持续的创新机制，让管理创新真正成为企业成长的内生动力。'
    ],
    areasTitle: '核心职能领域',
    areasSubtitle: '多维度的创新驱动体系',
    areas: [
      {
        title: '创新生态构建',
        icon: 'hub',
        image: require('@/assets/img/about-image1.jpg'),
        description: '搭建内外部协同创新网络，联动高校、研究机构、行业专家与企业，形成产学研用一体化的创新生态。'
      },
      {
        title: '战略咨询服务',
        icon: 'insights',
        image: require('@/assets/img/about-image2.jpg'),
        description: '围绕战略规划、组织升级、流程再造与数字化转型，为企业提供兼顾趋势判断与执行落地的咨询支持。'
      },
      {
        title: '方法论设计',
        icon: 'architecture',
        image: require('@/assets/img/about-image3.jpg'),
        description: '总结标杆经验与成功实践，沉淀标准化、可复制的创新管理方法，为企业内部推广应用提供抓手。'
      }
    ]
  },
  {
    slug: 'management-committee',
    badge: 'Committee Overview',
    title: '管理创新工作委员会',
    subtitle: '围绕企业高质量发展目标，持续完善管理创新标准、实践范式与协同推进机制。',
    heroImage: require('@/assets/img/about-image1.jpg'),
    missionTitle: '核心使命',
    missionParagraphs: [
      '管理创新工作委员会聚焦企业管理现代化发展的方向研究与协同推进，承担管理创新工作的组织引导、经验推广、课题研究和活动策划等任务。委员会通过构建行业交流平台，促进先进理念、优秀成果和成熟经验在更大范围内传播共享。',
      '委员会坚持问题导向与实践导向相结合，围绕企业在经营管理、组织治理、数字化转型和人才机制等方面的现实需求，建立常态化服务机制，推动企业把创新成果转化为管理能力、竞争优势和发展韧性。'
    ],
    areasTitle: '核心职能领域',
    areasSubtitle: '面向企业管理创新的协同服务体系',
    areas: [
      {
        title: '标准研究推广',
        icon: 'rule',
        image: require('@/assets/img/about-image2.jpg'),
        description: '研究管理创新的评价导向、工作标准与典型经验，推动形成面向企业实际场景的推广应用体系。'
      },
      {
        title: '专题交流组织',
        icon: 'groups',
        image: require('@/assets/img/about-image3.jpg'),
        description: '组织论坛、沙龙、专题研讨与培训活动，搭建企业间交流互鉴的平台，增强创新协同效应。'
      },
      {
        title: '实践成果转化',
        icon: 'conversion_path',
        image: require('@/assets/img/about-image.jpg'),
        description: '推动企业将管理创新成果从个案经验转化为制度、流程和机制，提升成果落地与复制能力。'
      }
    ]
  },
  {
    slug: 'achievement-review',
    badge: 'Review Framework',
    title: '管理创新成果审定委员会',
    subtitle: '依托专业评价与严谨审定机制，持续树立管理创新领域的成果标杆与价值导向。',
    heroImage: require('@/assets/img/about-image2.jpg'),
    missionTitle: '核心使命',
    missionParagraphs: [
      '管理创新成果审定委员会承担创新成果评价、专业审定与价值把关的重要职责，致力于建立科学、公正、规范的成果审定机制。委员会通过专家评议、标准对照和案例研判，推动优秀成果脱颖而出，为企业提供可学习、可借鉴、可推广的管理创新样本。',
      '委员会不仅关注成果本身的先进性和创新性，更重视成果在组织效能、经营质量、制度建设和社会价值等方面的综合表现，努力形成兼具专业高度与实践温度的评价体系，引导企业持续开展高质量管理创新。'
    ],
    areasTitle: '核心职能领域',
    areasSubtitle: '以专业审定机制守护成果质量',
    areas: [
      {
        title: '成果评价审定',
        icon: 'verified',
        image: require('@/assets/img/about-image3.jpg'),
        description: '围绕创新性、实践性、推广性与成效性开展综合评定，形成规范透明的成果审定流程。'
      },
      {
        title: '专家协同评审',
        icon: 'fact_check',
        image: require('@/assets/img/about-image.jpg'),
        description: '组织多领域专家参与成果评议与论证，确保审定过程具备专业深度和行业代表性。'
      },
      {
        title: '示范案例引领',
        icon: 'emoji_events',
        image: require('@/assets/img/about-image1.jpg'),
        description: '通过发布优秀成果和典型案例，树立行业标杆，带动更多企业在管理实践中持续创新。'
      }
    ]
  }
]

export function getAboutDepartments () {
  return aboutDepartments.slice()
}

export function getAboutDepartmentBySlug (slug) {
  const normalized = String(slug || '')
  return aboutDepartments.find(item => item.slug === normalized) || null
}



// WEBPACK FOOTER //
// ./src/utils/about.js